import { i18n } from 'core/i18n'
import actionTypes from 'constants/actionTypes'
import apiURLBuilder from 'core/apiURLBuilder'
import { APIPost, APIPostMb } from 'utilities/APIRequestHelper'
import { DEFAULT_ORIGIN_COUNTRY, LANGUAGE_COUNTRY_CODES } from 'constants/countries';

const { getLanguage } = i18n;

const resetAccountValidate = () => ({
  type: actionTypes.ACCOUNT_CANCELLATION_VALIDATION_RESET
})

const requestAccountCancellation = () => ({
  type: actionTypes.ACCOUNT_CANCELLATION_VALIDATION_REQUEST
});

const requestAccountCancellationSuccess = () => ({
  type: actionTypes.ACCOUNT_CANCELLATION_VALIDATION_SUCCESS,
});

const requestAccountCancellationRejected = (response) => ({
  type: actionTypes.ACCOUNT_CANCELLATION_VALIDATION_REJECTED,
  payload: {
    response
  }
});

const requestAccountCancellationFailure = (error) => ({
  type: actionTypes.ACCOUNT_CANCELLATION_VALIDATION_FAILURE,
  payload: {
    error
  }
});

const requestTransferAccountValidationRequest = () => ({
  type: actionTypes.TRANSFER_ACCOUNT_VALIDATION_REQUEST
});

const requestTransferAccountValidationRejected = (response) => ({
  type: actionTypes.TRANSFER_ACCOUNT_VALIDATION_REJECTED,
  payload: {
    response
  }
});

const requestTransferAccountValidationFailure = (error) => ({
  type: actionTypes.TRANSFER_ACCOUNT_VALIDATION_FAILURE,
  payload: {
    error
  }
});

const validateAccountCancellation = (oldContract, newContract) => (dispatch) => {
  dispatch(requestAccountCancellation())
  const data = {
    query: {
      oldContract,
      newContract,
    },
  };

  return APIPost(dispatch, apiURLBuilder.getURL('accountCancelValidation'), data)
    .then(response => {
      if (response) {
        dispatch(requestAccountCancellationRejected(response));
        return 
      }
      dispatch(requestAccountCancellationSuccess())
    })
    .catch(error => {
      dispatch(requestAccountCancellationFailure(error))
    });
};

const validateTransferAccount = (accountId, callbackToRedirect) => (dispatch) => {
  dispatch(requestTransferAccountValidationRequest())

  const acceptLanguage = LANGUAGE_COUNTRY_CODES[getLanguage()] || LANGUAGE_COUNTRY_CODES[DEFAULT_ORIGIN_COUNTRY];
  const data = {
    header: {
      "accept-language": acceptLanguage,
    },
    query: {
      accountId
    },
  };

  return APIPostMb(dispatch, apiURLBuilder.getModelURL('transferAccountValidation'), data)
    .then(response => {
      if (response) {
        dispatch(requestTransferAccountValidationRejected(response));
        return 
      }
      callbackToRedirect()
    })
    .catch(error => {
      dispatch(requestTransferAccountValidationFailure(error))
    });
};

module.exports = {
  validateAccountCancellation,
  resetAccountValidate,
  validateTransferAccount,
};
